import Lenis from 'lenis'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import Header from '../../blocks/header/scripts.js'
import Footer from '../../blocks/footer/scripts.js'
import Hero from '../../blocks/hero/scripts.js'
import ChambreDetailSlider from '../../blocks/chambre-detail/scripts.js'
import HeroSearch from '../../blocks/hero-search/scripts.js'
import HeroSlider from '../../blocks/hero-slider/scripts.js'
import ImgLink from '../../blocks/img-link/scripts.js'
import TextImg from '../../blocks/text-img/scripts.js'
import DoubleImg from '../../blocks/double-img/scripts.js'
import TitleText from '../../blocks/title-text/scripts.js'
import Citation from '../../blocks/citation/scripts.js'
import TextImageSlider from '../../blocks/text-image-slider/scripts.js'
import SliderActus from '../../blocks/slider-actus/scripts.js'
import ArticleBlog from '../../blocks/article-blog/scripts.js'
import Blog from '../../blocks/blog/scripts.js'
import SliderNav from '../../blocks/slider-nav/scripts.js'
import Testimonials from '../../blocks/testimonials/scripts.js'
import SliderInsta from '../../blocks/slider-insta/scripts.js'
import BannerInfo from '../../blocks/banner-info/scripts.js'
import Accordeon from '../../blocks/accordeon/scripts.js'
import TitleCta from '../../blocks/title-cta/scripts.js'
import Contact from '../../blocks/contact/scripts.js'
import Maps from '../../blocks/maps/scripts.js'
import TextImgList from '../../blocks/text-img-list/scripts.js'
import SideLinks from '../../blocks/side-links/scripts.js'
import AccessInfo from '../../blocks/access-info/scripts.js'
import { initReveal } from './utils/reveal.js'
import initParallax from './utils/parallax.js'
import Popup from '../../blocks/popup/scripts.js'

gsap.registerPlugin(ScrollTrigger)

const lenis = new Lenis({
  autoRaf: false,
  lerp: 0.06,
  easing: 'ease-in-out',
  wheelMultiplier: 0.7
})

window.lenis = lenis

lenis.on('scroll', ScrollTrigger.update)

gsap.ticker.add((time) => {
  lenis.raf(time * 1000)
})

gsap.ticker.lagSmoothing(0)

// Weglot traduit le DOM après le load → recalcul des hauteurs pour Lenis et ScrollTrigger
window.addEventListener('load', () => {
  lenis.resize()
  ScrollTrigger.refresh()
})

// Ancres internes (href="#id") : sans ça, le saut natif du navigateur est instantané
// et Lenis le rejoue ensuite depuis son ancienne position, donnant l'impression que
// le scroll ne va pas directement à la section.
document.addEventListener('click', (e) => {
  const link = e.target.closest('a[href^="#"]')
  if (!link || link.getAttribute('href') === '#') return

  const target = document.querySelector(link.getAttribute('href'))
  if (!target) return

  e.preventDefault()
  const headerHeight = document.querySelector('.header--nav')?.offsetHeight || 0
  lenis.scrollTo(target, { offset: -headerHeight })
})

document.addEventListener('DOMContentLoaded', () => {

  document.querySelectorAll('.header').forEach(el => new Header(el))
  document.querySelectorAll('.footer').forEach(el => new Footer(el))
  document.querySelectorAll('.hero').forEach(el => new Hero(el))
  document.querySelectorAll('.chambre-detail').forEach(el => new ChambreDetailSlider(el))
  document.querySelectorAll('.hero-search').forEach(el => new HeroSearch(el))
  document.querySelectorAll('.hero-slider').forEach(el => new HeroSlider(el))
  document.querySelectorAll('.img-link').forEach(el => new ImgLink(el))
  document.querySelectorAll('.text-img').forEach(el => new TextImg(el))
  document.querySelectorAll('.double-img').forEach(el => new DoubleImg(el))
  document.querySelectorAll('.title-text').forEach(el => new TitleText(el))
  document.querySelectorAll('.citation').forEach(el => new Citation(el))
  document.querySelectorAll('.text-image-slider').forEach(el => new TextImageSlider(el))
  document.querySelectorAll('.slider-actus').forEach(el => new SliderActus(el))
  document.querySelectorAll('.article-blog').forEach(el => new ArticleBlog(el))
  document.querySelectorAll('.blog').forEach(el => new Blog(el))
  document.querySelectorAll('.slider-nav').forEach(el => new SliderNav(el))
  document.querySelectorAll('.testimonials').forEach(el => new Testimonials(el))
  document.querySelectorAll('.slider-insta').forEach(el => new SliderInsta(el))
  document.querySelectorAll('.banner-info').forEach(el => new BannerInfo(el))
  document.querySelectorAll('.accordeon').forEach(el => new Accordeon(el))
  document.querySelectorAll('.title-cta').forEach(el => new TitleCta(el))
  document.querySelectorAll('.contact').forEach(el => new Contact(el))
  document.querySelectorAll('.maps').forEach(el => new Maps(el))
  document.querySelectorAll('.text-img-list').forEach(el => new TextImgList(el))
  document.querySelectorAll('.side-links').forEach(el => new SideLinks(el))
  document.querySelectorAll('.access-info').forEach(el => new AccessInfo(el))
  document.querySelectorAll('.garance-popup').forEach(el => new Popup(el))
  
  initReveal()
  initParallax();
});